export type ListSortDir = 'desc' | 'asc'

export function appendSortDir(url: string, sortDir: ListSortDir = 'desc'): string {
  const sep = url.includes('?') ? '&' : '?'
  return `${url}${sep}sortDir=${sortDir}`
}
